export type TopBarTranslation = {
  feedback: string;
  instruction: string;
  language: string;
  lng: {
    english: string;
    polish: string;
  };
  logout: string;
  notifications: {
    noNotifications: string;
    seeAll: string;
    tooltip: string;
  };
  profile: string;
  start: string;
  theme: {
    dark: string;
    label: string;
    light: string;
  };
};

export const topBarTranslation: TopBarTranslation = {
  feedback: 'Share your feedback',
  instruction: 'Instruction',
  language: 'Language',
  lng: {
    english: 'English',
    polish: 'Polish',
  },
  logout: 'Log out',
  notifications: {
    noNotifications: 'No new notifications',
    seeAll: 'See all notifications',
    tooltip: 'Notifications',
  },
  profile: 'My profile',
  start: 'Start',
  theme: {
    dark: 'Dark theme',
    label: 'Theme',
    light: 'Light theme',
  },
};
